/**
 * System phase constants for workflow engine
 */
export const SYSTEM_PHASES = {
  setup: { id: "_system_setup", label: "System Setup" },
  finalize: { id: "_system_finalize", label: "System Finalize" },
} as const;
